<template>
  <component
    :is="tag"
    v-bind="$attrs">
    {{ formattedValue }}
    <!-- <slot>
    </slot> -->
  </component>
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, String],
      required: true
    },
    format: {
      type: Function
    },
    // displayedValue: {
    //   type: Number,
    //   required: true
    // },
    speed: {
      default: 2000,
      type: Number
    },
    tag: {
      default: 'span',
      type: String
    }
  },
  watch: {
    value: function (newValue, oldValue) {
      this.animate(oldValue, newValue);
    }
  },
  data() {
    return {
      displayedValue: 0
    }
  },
  computed: {
    formattedValue() {
      return this.format ? this.format(this.displayedValue) : this.displayedValue;
    },
    nDecimals({ value }) {
      return this.countDecimals(value);
    }
  },
  mounted() {
    this.animate(0, this.value);
  },
  methods: {
    countDecimals(value) {
      if (value && (value % 1) != 0)
          return value.toString().split(".")[1].length;
      return 0;
    },
    animate(startValue, endValue) {

      var vm = this;
      const { speed, nDecimals } = this;
      const change = endValue - startValue;
      // if (this.value == this.displayedValue) {
      //   return;
      // }
      //
      // this.interval = window.setInterval( function (){
      //
      //   if(vm.displayedValue != vm.value){
      //     var change = (vm.value - vm.displayedValue) / 10;
      //     change = change >= 0 ? Math.ceil(change) : Math.floor(change);
      //     vm.$emit('update:displayedValue', vm.displayedValue + change)
      //   }
      //
      // }, int);
      //
      var start = null;

      function step(timestamp) {
        if (!start) start = timestamp;
        const progress = timestamp - start;
        const add = Math.min(progress / speed, 1) * change;

        const displayed = vm.$options.filters.round(startValue + add, nDecimals);
        vm.displayedValue = displayed;

        if (progress < speed) {
          window.requestAnimationFrame(step);
        }
      }

      window.requestAnimationFrame(step);
    }
  }
}
</script>

<style scoped>
</style>
